import SessionStore from 'ember-simple-auth/session-stores/session-storage';

export default class AppSessionStore extends SessionStore {}
